import React, { Fragment } from "react";
import PhoneInput from "react-phone-input-2";
import UserSearchInputWrapper from "../../../Common/user/UserSearchInputWrapper";
import FormInput from "../../../Common/FormInputs/MuiTextField";
import AppButton from "../../../Common/Button/Button";
import { Box } from "@mui/material";
import { SearchSectionLabel, SectionHeading } from "../../../Common/Typography/AppTypography";
import Grid2 from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import { selectMenuProps } from "../../../../utils/selectMenuProps";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../../../theme/useDesignTokens";
import { useSidebarContext } from "../../../../context/SidebarContext";

/**
 * User Details search – matches SearchDevice layout structure
 */
const UserSearchBar = (props) => {
  const fieldHeight = 45;
  const defaultBorderColor = "rgba(0, 0, 0, 0.42)";
  const theme = useTheme();
  const { colors } = useDesignTokens();
  const { isAnySidebarStateExpanded } = useSidebarContext();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;

  return (
    <UserSearchInputWrapper
      onSubmitSuccess={props.onSubmitSuccess}
      onSubmitFailure={props.onSubmitFailure}
    >
      {({
        searchValue,
        searchBy,
        countryCode,
        onSubmit,
        setCountryCode,
        onSearchByChange,
        onSearchValueChange,
        allowedCountries,
      }) => (
        <Fragment>
          <Grid2 container spacing={2}>
            <Grid2 size={12}
              sx={{
                p: 2,
                borderRadius: 1,
                boxShadow: 2,
                bgcolor: "background.paper",
              }}
            >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", lg: "auto 1fr" },
                    rowGap: 2,
                    columnGap: { xs: 2, lg: "116px" },
                    alignItems: "center",
                  }}
                >
                <SectionHeading sx={{ mb: 0 }}>
                  Search User
                </SectionHeading>
                <Box
                  component="form"
                  onSubmit={onSubmit}
                  sx={{
                    display: "grid",
                    gap: 1.5,
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "1fr",
                      md: isAnySidebarStateExpanded
                        ? "1fr"
                        : "90px 180px minmax(200px, 1fr) auto",
                      lg: "90px 200px minmax(220px, 320px) 100px",
                    },
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "start",
                  }}
                >
                  <SearchSectionLabel>Search By</SearchSectionLabel>
                  <FormInput
                    type="select"
                    size="small"
                    fullWidth
                    name="searchBy"
                    value={searchBy}
                    onChange={(e) => onSearchByChange(e)}
                    MenuProps={selectMenuProps}
                    options={[
                      { value: "mobile", label: "Mobile No" },
                      { value: "email", label: "Email Id" },
                    ]}
                    sx={{
                      minWidth: {
                        xs: "100%",
                        sm: "100%",
                        md: isAnySidebarStateExpanded ? "100%" : 180,
                        lg: 200,
                      },
                      maxWidth: {
                        xs: "100%",
                        sm: "100%",
                        md: isAnySidebarStateExpanded ? "100%" : 180,
                        lg: 200,
                      },
                      "& .MuiOutlinedInput-root": { height: fieldHeight },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: `1px solid ${defaultBorderColor} !important`,
                      },
                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: `${primaryColor} !important`,
                        borderWidth: "1px",
                      },
                      "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline, & .Mui-expanded .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.42) !important",
                        borderWidth: "1px",
                      },
                      "& .MuiSelect-select": {
                        display: "flex",
                        alignItems: "center",
                        minHeight: `${fieldHeight}px !important`,
                      },
                      "& .MuiSelect-icon": {
                        color: "rgba(0, 0, 0, 0.54)",
                      },
                      "& .Mui-focused .MuiSelect-icon": {
                        color: primaryColor,
                      },
                    }}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      gap: 0,
                      width: "100%",
                      alignItems: "stretch",
                      flexWrap: "nowrap",
                      minWidth: 0,
                      overflow: "visible",
                      "&:focus-within .user-search-phone-wrap .react-tel-input .flag-dropdown": {
                        border: `1px solid ${primaryColor} !important`,
                      },
                      "&:focus-within .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px !important",
                      },
                    }}
                  >
                    {searchBy === "mobile" && (
                      <Box
                        className="user-search-phone-wrap"
                        sx={{
                          width: 54,
                          height: `${fieldHeight}px`,
                          minHeight: `${fieldHeight}px`,
                          maxHeight: `${fieldHeight}px`,
                          flexShrink: 0,
                          marginRight: 0,
                          alignSelf: "stretch",
                          overflow: "visible",
                          "& .react-tel-input": {
                            width: "100%",
                            height: `${fieldHeight}px`,
                            minHeight: `${fieldHeight}px`,
                            maxHeight: `${fieldHeight}px`,
                            margin: 0,
                            overflow: "visible",
                          },
                          "& .react-tel-input .form-control": {
                            display: "none !important",
                            width: "0 !important",
                            minWidth: "0 !important",
                            height: `${fieldHeight}px !important`,
                            minHeight: `${fieldHeight}px`,
                            borderRadius: "4px 0 0 4px",
                            borderRight: "none",
                            borderColor: "transparent",
                            paddingLeft: "0",
                            paddingRight: "0",
                            fontSize: "14px",
                            color: "transparent",
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            pointerEvents: "none",
                          },
                          "& .react-tel-input .flag-dropdown": {
                            height: `${fieldHeight}px !important`,
                            minHeight: `${fieldHeight}px !important`,
                            maxHeight: `${fieldHeight}px !important`,
                            top: 0,
                            margin: 0,
                            borderRadius: "4px 0 0 4px",
                            border: `1px solid ${defaultBorderColor} !important`,
                            backgroundColor: "background.paper",
                            width: "54px",
                            boxSizing: "border-box",
                            zIndex: 2,
                            position: "relative",
                            overflow: "visible",
                          },
                          "& .react-tel-input .flag-dropdown.open": {
                            border: `1px solid ${primaryColor} !important`,
                          },
                          "& .react-tel-input .flag-dropdown.open .selected-flag": {
                            position: "relative",
                            zIndex: 3,
                            borderRight: `1px solid ${primaryColor}`,
                            borderBottom: `1px solid ${primaryColor}`,
                          },
                          "& .react-tel-input .selected-flag": {
                            height: `${fieldHeight}px`,
                            width: "54px",
                            padding: "0 0 0 10px",
                          },
                          "& .react-tel-input .selected-flag:hover": {
                            backgroundColor: "transparent !important",
                          },
                          "& .react-tel-input .country-list": {
                            border: `1px solid ${defaultBorderColor}`,
                            backgroundColor: "#fff",
                            boxSizing: "border-box",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                            marginTop: 2,
                            marginLeft: 0,
                            zIndex: 3,
                          },
                        }}
                      >
                        <PhoneInput
                          enableSearch={false}
                          value={countryCode}
                          onChange={setCountryCode}
                          onlyCountries={allowedCountries}
                        />
                      </Box>
                    )}

                    <FormInput
                      id="user-search-value"
                      type="text"
                      fullWidth
                      size="small"
                      margin="none"
                      placeholder={
                        searchBy === "mobile"
                          ? "Mobile No Without Country Code"
                          : "Enter Email Id"
                      }
                      name="text"
                      value={searchValue}
                      onChange={onSearchValueChange}
                      startAdornment={searchBy === "email" ? <SearchIcon fontSize="small" /> : null}
                      sx={{
                        margin: 0,
                        alignSelf: "stretch",
                        "& .MuiOutlinedInput-root": {
                          height: fieldHeight,
                          minHeight: fieldHeight,
                          maxHeight: fieldHeight,
                          marginTop: 0,
                          position: "relative",
                          zIndex: 1,
                          borderTopLeftRadius: searchBy === "mobile" ? "0 !important" : undefined,
                          borderBottomLeftRadius: searchBy === "mobile" ? "0 !important" : undefined,
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: `1px solid ${defaultBorderColor} !important`,
                          ...(searchBy === "mobile"
                            ? { borderLeft: "none !important" }
                            : {}),
                        },
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: `${primaryColor} !important`,
                          borderWidth: "1px !important",
                          ...(searchBy === "mobile"
                            ? { borderLeft: "none !important" }
                            : {}),
                        },
                        "& .MuiInputBase-input": {
                          height: `${fieldHeight}px !important`,
                          boxSizing: "border-box",
                        },
                      }}
                    />
                  </Box>

                  <AppButton
                    type="submit"
                    variant="primary"
                    size="medium"
                    sx={{
                      minWidth: 100,
                      width: { xs: "100%", md: "auto" },
                      justifySelf: { xs: "start", md: "start" },
                    }}
                  >
                    Search
                  </AppButton>
                </Box>
                </Box>
            </Grid2>
          </Grid2>
        </Fragment>
      )}
    </UserSearchInputWrapper>
  );
};

export default UserSearchBar;
